window._ = require('lodash');

try {
    window.$ = window.jQuery = require('jquery');

    require('foundation-sites');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */
let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}


/*
  Imports the routes, store, i18n and vue to use with the Vue module.
*/
import Vue from 'vue';
import router from './routes.js'
import store from './store.js'
import i18n from './i18n.js'
import cc from './cc.js'

new Vue({
    router,
    store,
    i18n,
    mounted: function() {
        cc.runCookieConsent()
    }
}).$mount('#app')

/*
  Send google analytics the current path.
*/
//ga('set', 'page', router.currentRoute.path);
//ga('send', 'pageview');

/*
  After each page navigation, send the path to Google analytics.
*/
router.afterEach(( to, from ) => {
  //ga('set', 'page', to.path);
  //ga('send', 'pageview');
});
